import React, { useState, useEffect } from 'react';
import { Star, Save, Info } from 'lucide-react';
import api from '../../services/api';

const ConfiguracoesAvaliacao = () => {
    const [loading, setLoading] = useState(true);
    const [saving, setSaving] = useState(false);
    
    const [isEnabled, setIsEnabled] = useState(false);
    const [message, setMessage] = useState('');

    // Carregar configurações ao montar
    useEffect(() => {
        const fetchSettings = async () => {
            try {
                const res = await api.get('/api/settings/bot');
                const data = res.data || {};
                setIsEnabled(data.evaluationActive || false);
                setMessage(data.evaluationMessage || 'Por favor, avalie nosso atendimento com uma nota de 0 a 10.');
            } catch (error) {
                console.error('Erro ao carregar configurações de avaliação:', error);
            } finally {
                setLoading(false);
            }
        };
        fetchSettings();
    }, []);

    // Salvar configurações
    const handleSave = async () => {
        setSaving(true);
        try {
            await api.put('/api/settings/bot', {
                evaluationActive: isEnabled,
                evaluationMessage: message,
            });
            alert('Configurações de avaliação salvas com sucesso!');
        } catch (error) {
            console.error('Erro ao salvar:', error);
            alert('Erro ao salvar configurações.');
        } finally {
            setSaving(false);
        }
    };

    if (loading) return <div className="p-4 text-gray-500">Carregando configurações...</div>;

    return (
        <div className="bg-white p-6 rounded-lg shadow-md border border-gray-200 mt-6">
            <div className="flex items-center mb-4 text-yellow-600">
                <Star className="w-6 h-6 mr-2 fill-yellow-500" />
                <h2 className="text-xl font-bold text-gray-700">Pesquisa de Satisfação (NPS)</h2>
            </div>

            <div className="space-y-6">
                {/* Toggle de Ativação */}
                <div className="flex items-center justify-between bg-gray-50 p-4 rounded-md border border-gray-100">
                    <div>
                        <h3 className="font-semibold text-gray-800">Habilitar Avaliação ao Encerrar</h3>
                        <p className="text-sm text-gray-500">
                            Quando ativado, o bot enviará a mensagem abaixo assim que um atendente encerrar o ticket.
                        </p>
                    </div>
                    <label className="relative inline-flex items-center cursor-pointer">
                        <input 
                            type="checkbox" 
                            className="sr-only peer" 
                            checked={isEnabled}
                            onChange={(e) => setIsEnabled(e.target.checked)}
                        />
                        <div className="w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-green-600"></div>
                    </label>
                </div>

                {/* Área de Texto */}
                <div className={`transition-opacity duration-300 ${!isEnabled ? 'opacity-50 pointer-events-none' : 'opacity-100'}`}>
                    <label className="block text-sm font-bold text-gray-700 mb-2">
                        Mensagem de Solicitação de Nota
                    </label>
                    <textarea 
                        value={message} 
                        onChange={(e) => setMessage(e.target.value)} 
                        className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500" 
                        rows="3"
                        placeholder="Ex: Como você avalia nosso atendimento? Responda com uma nota de 0 a 10."
                    ></textarea>
                    <div className="flex items-start mt-2 text-xs text-blue-600 bg-blue-50 p-2 rounded">
                        <Info className="w-4 h-4 mr-1 flex-shrink-0" />
                        <p>
                            O sistema aguardará a próxima mensagem do cliente. Se for um número de 0 a 10, será registrado como nota do atendimento.
                        </p>
                    </div>
                </div>

                {/* Botão Salvar */}
                <button 
                    onClick={handleSave} 
                    disabled={saving}
                    className="w-full flex items-center justify-center bg-blue-600 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded transition-colors disabled:bg-gray-400"
                >
                    <Save className="w-4 h-4 mr-2" />
                    {saving ? 'Salvando...' : 'Salvar Configurações de Avaliação'}
                </button>
            </div>
        </div>
    );
};

export default ConfiguracoesAvaliacao;